var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__a",
  d: "M15 30C6.716 30 0 23.284 0 15 0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "prefix__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#1542C3",
  xlinkHref: "#prefix__a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#1542C3",
  mask: "url(#prefix__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H32V32H0z",
  transform: "translate(-1 -1)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  stroke: "#FFF",
  strokeWidth: 0.5
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M4.99 5.763l4.516 4.512c.124.124.324.124.447 0 .124-.123.124-.323 0-.446L5.66 5.54l4.293-4.288c.124-.124.124-.323 0-.447C9.892.743 9.811.713 9.73.713c-.081 0-.162.03-.224.092L4.99 5.317c-.123.123-.123.323 0 .446",
  transform: "rotate(45 -1.188 22)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.402 5.763L.884 10.275c-.123.124-.323.124-.446 0-.124-.123-.124-.323 0-.446L4.73 5.54.438 1.252C.314 1.128.314.929.438.805.499.743.58.713.66.713c.08 0 .162.03.223.092l4.518 4.512c.123.123.123.323 0 .446",
  transform: "rotate(45 -1.188 22)"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add.ac740341c6cdade490584412937adbc7.svg";